import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TableRow {
    LanguageCode: string;
    Title: string;
    Description: string;
    ProductId: number;
}

interface TranslationRowField {
    name: string;
    input: boolean;
}

function ProductTranslationTable(props) {
    useEffect(() => {
        setTranslationRowFields(props.fields);
        setRows(props.rows);
    }, [props])
    const [rows, setRows] = useState<TableRow[]>([]);
    const [translationRowFields, setTranslationRowFields] = useState<TranslationRowField[]>([]);
    const { t } = useTranslation();

    const handleUpdateField = (newRows: TableRow[]) => {
        props.handleRowSet(newRows);
        setRows(newRows);
    };

    const clearValues = (index: number) => {
        const newRows = [...rows];

        translationRowFields.forEach(field => {
            if (field.input) {
                newRows[index][field.name] = '';
            }
        });

        handleUpdateField(newRows);
    };

    return (
        <div className="bg-gray-900 text-gray-200 p-4">
            <div className="flex flex-col space-y-4">
                <div className="flex items-center space-x-2">
                    <h3>{t('producttranslationtable.product-translations')} - {props.productName}</h3>
                </div>
                <table className="w-full border-collapse">
                    <thead>
                        <tr className="bg-gray-800">
                            <th className="border-b border-gray-700 p-3" align='left'>{t('generic.language')}</th>
                            <th className="border-b border-gray-700 p-3" align='left'>{t('generic.name')}</th>
                            <th className="border-b border-gray-700 p-3" align='left'>{t('generic.description')}</th>
                            <th className="border-b border-gray-700 p-3" align='left'>{t('generic.action')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={row.LanguageCode} className="border-b border-gray-800">
                                {
                                    translationRowFields.map(field => {
                                        if (field.input) {
                                            return <td className="p-3">
                                                <input
                                                    type="text"
                                                    maxLength={64}
                                                    value={row[field.name]}
                                                    onChange={(e) => {
                                                        const newRows = [...rows];
                                                        newRows[index][field.name] = e.target.value;
                                                        handleUpdateField(newRows);
                                                    }}
                                                    className="w-full bg-gray-800 border border-gray-700 rounded px-2 py-1 text-gray-200"
                                                    style={{ width: '100%' }}
                                                />
                                            </td>
                                        } else {
                                            return <td>
                                                {row[field.name].toUpperCase()}
                                            </td>
                                        }

                                    })
                                }
                                <td className="p-3">
                                    <button
                                        onClick={() => clearValues(index)}
                                        className="w-8 h-8 flex items-center justify-center rounded-md bg-red-600 text-white hover:bg-red-700"
                                        aria-label="Delete Row"
                                    >
                                        &#10134;
                                    </button>
                                </td>                                
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProductTranslationTable;